import { useContext } from 'react';
import { InventoryContext } from 'common/context/inventory/inventory.context';

export const useInventoryContext = () => useContext(InventoryContext);
